/**
 * Settings → Team (M-1). GET stays an array so existing E2E keeps passing.
 */
import { apiFetch } from './client'

export type TeamRole = 'owner' | 'admin' | 'finance' | 'member'

export type TeamMember = {
  id: number
  user_id: number | null
  name: string | null
  email: string
  role: TeamRole | string
  joined: string | null
  status: 'active' | 'pending'
  seats_used?: number
  seat_limit?: number
  company_id?: number
}

export async function loadTeam(): Promise<TeamMember[]> {
  const rows = await apiFetch<TeamMember[]>('GET', '/api/team')
  return Array.isArray(rows) ? rows : []
}

export async function inviteTeamMember(body: { email: string; name?: string; role: string }): Promise<TeamMember> {
  return apiFetch<TeamMember>('POST', '/api/team', body)
}

export async function changeTeamRole(userId: number, role: string): Promise<unknown> {
  return apiFetch('PUT', `/api/team/members/${userId}`, { role })
}

export async function removeTeamMember(userId: number): Promise<void> {
  await apiFetch('DELETE', `/api/team/members/${userId}`)
}

export async function cancelTeamInvite(id: number): Promise<void> {
  await apiFetch('DELETE', `/api/team/${id}`)
}
